import ajax from '../ajax';
// 关于我们信息请求
export const getMessageInfo = (data: any) => ajax('/v3/admin/web/about/getAbout', data, 'GET');

// 关于我们编辑
export const editMessageInfo = (data: any) => ajax('/v3/admin/web/about/saveAbout', data, 'POST');
